import { types } from "mobx-state-tree"


import {dateRegexFormat, formatDate} from "../../lib/formatDate"

export const dateType = types.refinement(types.string, value => {
    return dateRegexFormat.test(value) || !value
})

export const today = formatDate(Date.now())